<template>
    <div class="container-fluid">
        <div class="row mt-2 mb-5">
            <div class="offset-md-2 col-md-8 col-12">
                <template v-if="theStoredOrderResult && theStoredOrderResult.shopperNoPwd && showCreatePassword">
                    <!-- display optional password -->
                    <app-create-password 
                        @emitCreatePasswordFxn="hideCreatePasswordFxn"
                        :shopperEmail="theStoredOrderResult.shopperEmail" 
                        :shopperConfToken="theStoredOrderResult.shopperConfToken" 
                        class="mb-5">
                    </app-create-password>
                </template>

                <template v-else>
                    <!-- display order number -->
                    <div v-if="orderNumber" class="row mb-5">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-body">
                                    <p class="order-placed">Thank you! Your order #{{orderNumber}} has been successfully submitted!</p>
                                    <p>This is a confirmation that we have received your order and will start working on it soon!</p>
                                    <p>You will also receive an email with your "Order Number" and tracking details shortly!</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- display order failed msg -->
                    <div v-else class="row mb-3">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-body">
                                    <p class="order-placed">Oh noo! You may have to try again :(</p>
                                    <p>Unfortunately, we are unable to create your order at this time.</p>
                                    <p>Please try placing your order again and we will start processing your order as soon as possible.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- mobile view buttons for track order and continue shopping -->
                    <div class="row my-4 d-sm-none">
                        <div class="col-12 text-center">
                            <router-link v-if="orderNumber" :to="{ name: 'customer-order', params: { orderNum: `${orderNumber}` } }" class="btn btn-dark mb-2 form-control">
                                Track Order
                            </router-link>
                            <router-link :to="{ name: 'home' }" class="btn btn-dark-green mb-2 form-control">
                                Continue Shopping
                            </router-link>
                        </div>
                    </div>

                    <!-- desktop view buttons for track order and continue shopping -->
                    <div class="row my-4 d-none d-sm-block">
                        <div class="col-12">
                            <div class="clearfix">
                                <router-link :to="{ name: 'home' }" class="btn btn-dark-green float-sm-left">
                                    Continue Shopping
                                </router-link>
                                <router-link v-if="orderNumber" :to="{ name: 'customer-order', params: { orderNum: `${orderNumber}` } }" class="btn btn-dark float-sm-right">
                                    Track Order
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <!-- explore categories -->
                    <div class="mb-5">
                        <app-more-categories :displayedCategory="'none'"></app-more-categories>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MoreCategories from '../itemDetailsParts/MoreCategories.vue';
import LayoutGeneral from '@/layouts/General.vue'
import CreatePassword from '@/components/auth/pages/CreatePassword.vue';

export default {
    name: "OrderConfirmation",
    props: {
        orderNumber: {
            type: Number,
            required: false
        }
    },
    data() {
        return {
            showCreatePassword: true
        }
    },
    methods: {
        redirectToOrdersFxn(theOrderNumber) {
            // do not redirect if there is an order number
            if(theOrderNumber) return
            
            // send the shopper to orders page if user is logged in otherwise they will land at 
            if(this.loggedInUser){
                this.$router.push({ name: 'customer-orders' }).catch((e) => {})
            }

            // send to view currently placed order
            if(this.theStoredOrderResult){
                this.$router.push({ 
                    name: 'customer-order', 
                    params: { orderNum: `${this.theStoredOrderResult.orderNumber}` } 
                }).catch((e) => {})
            }

            // // final resort - send the shopper back to home page if not logged in
            // this.$router.push({ name: 'home' }).catch((e) => {})
        },
        hideCreatePasswordFxn() {
            // only turn off showCreatePassword variable if ani_items_sor has value - added security
            if(!this.theStoredOrderResult) return
            this.showCreatePassword = false

            // remove other value from the ani_items_sor leaving just the orderNumber - security reasons
            let orderNumberObj = {
                orderNumber: this.orderNumber
            }
            localStorage.setItem('ani_items_sor', JSON.stringify(orderNumberObj))
        }
    },
    computed: {
        ...mapGetters(['user', 'authenticated']),
        loggedInUser() {
            if(this.authenticated && this.user){
                return this.user
            }
            return false
        },
        theStoredOrderResult() {
            // fetch shopper items from cart if any
            let localStorageSORData = JSON.parse(localStorage.getItem('ani_items_sor')) 
            if(localStorageSORData) {
                return localStorageSORData
            }
            return false
        }
    },
    components: {
        appMoreCategories: MoreCategories,
        appCreatePassword: CreatePassword
    },
    watch: {
        orderNumber(){
            this.redirectToOrdersFxn(this.orderNumber)
        }
    },
    created() {
        this.redirectToOrdersFxn(this.orderNumber)
        this.$emit('update:layout', LayoutGeneral);
    }
}
</script>